import { getVideoPreviewPath, isGenericVideoPosterPath } from "@/utils/content-adapter.mjs";

const StaticVideoPreview = ({
  src,
  poster,
  className,
  controls = false,
  ...props
}) => {
  const safePoster = poster && !isGenericVideoPosterPath(poster) ? poster : undefined;
  const videoSrc = controls ? src : getVideoPreviewPath(src);

  return (
    <video
      {...props}
      src={videoSrc}
      poster={safePoster}
      className={className}
      muted
      playsInline
      preload="metadata"
      controls={controls}
      controlsList={
        controls
          ? "nodownload noremoteplayback"
          : "nodownload nofullscreen noremoteplayback"
      }
      disablePictureInPicture
    />
  );
};

export default StaticVideoPreview;
